<template>
	<div>
		<section class="container-fluid mt-2">
			<div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <nav class="navbar navbar-breadcrumb navbar-expand-md bg-breadcrumb breadcrumb-borde">
                        <div class="mr-auto">
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb clearfix pt-3">
                                    <li class="breadcrumb-item active">Flota</li>
                                </ol>
                            </nav>
                        </div>
                    </nav>
                </div>
            </div>
			<div class="row">
				<div class="col-lg-12 mt-2">
					<Clist :isCrm="true" :pShowBtnAdd="ShowBtns" :ShowHead="false" @FiltrarC="Lista" :Filtro="Filtro" :regresar="true"  :Nombre="NameList"  :isModal="EsModal" :pConfigLoad="ConfigLoad" :isContactos="true">
						<template slot="Filtros">
                        </template>
						<template slot="cards">
							<div class="row row-cols-md-2 row-cols-lg-2 row-cols-xl-2 mt-3">
								<div v-for="(lista,key,index) in ListaVehiculos" :key="index" class="col-sm-2 col-md-2 card-group">
									<div @click="IrATarjeta(lista.IdVehiculo)" class="card mb-3 tarjetacliente" style="border:2px solid #0F3F87;cursor:pointer;">
										<img height="190px" v-if="lista.Foto!=null && lista.Foto!=''" class="card-img-top" :src="RutaImagenVehiculo+lista.Foto" alt=""/>
										<div v-else class="card-img-top" style="background-color:#b4b4b4;padding:75px;height:190px"></div>
										<div class="card-body pt-2">
											<div class="row mt-1">
												<div class="col-lg-12">
													<h6 class="m-0">
                                        	            {{lista.Vehiculo.toUpperCase() }}
                                        	        </h6>
													<b>Marca: </b> {{ lista.Marca }}
													<br>
													<b>Modelo: </b>{{ lista.Modelo }}
													<br>
													<b>Año: </b>{{lista.Ano}}
													<br>
													<b>Placa: </b>{{lista.Placa}}
													<br>
													<b>Número:</b> {{ lista.Numero }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>
						
					</Clist>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import Clist from '@/components/Clist.vue';
export default {
	name :'list',
    props:[],
    components :{
        Clist
        // Menu,
    },
	data() {
		return {
			NombreSeccion: 'Flotilla',
            FormName:'FlotillaForm',
            EsModal:true,
            size :"modal-lg",
            NameList:"Flotilla",
            EmitSeccion:"Flotilla",
            // EmitSeccionTrabajador:"AgregarTrabajador",
            urlApi:"vehiculo/get",
            ListaVehiculos:[],
            ShowBtns:true,
            TipoList:'',
            Filtro:{
                Nombre:'',
                Placeholder:'Nombre/Marca/Modelo..',
                TotalItem:0,
                Pagina:1,
                Entrada:30
            },
            oBtnSave:{
                isModal:true,
                disableBtn:false,
                toast:0,
                nombreModal:"Vehiculo",
                EmitSeccion:'Vehiculo'
            },
            ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true,
			},
            RutaImagenVehiculo:"",
		}
	},
	methods: {
		async Lista(){
			this.ConfigLoad.ShowLoader = true;
			await this.$http.get(
                this.urlApi,
                {
                    params:{
                        Nombre: this.Filtro.Nombre,
						Entrada: this.Filtro.Entrada,
						pag: this.Filtro.Pagina,
						RegEstatus: 'A',
                    }
                }
            ).then((res)=>{
                this.ListaVehiculos = res.data.data.vehiculo;
				this.RutaImagenVehiculo=res.data.data.rutavehiculo;
				this.Filtro.Entrada = res.data.data.pagination.PageSize;
				this.Filtro.TotalItem = res.data.data.pagination.TotalItems;
            }).finally(()=>{
				this.ConfigLoad.ShowLoader = false;
			});
		},
		IrATarjeta(IdVehiculo){
			this.$router.push({name:'flotilladetalle',params:{Id:IdVehiculo,pOrigen:'Tarjeta'}});
		}
	},
	created() {
		this.bus.$off('List');
		this.bus.$on('List',()=> 
        {
            this.Lista();
        });
	},
	mounted() {
		this.Lista();
	},
}
</script>

<style>

</style>
